<template>
  <div class="payment">
    <van-form label-width="80px">
      <van-field v-model="order.matchName" name="matchName" label="赛事名称" readonly />
      <van-field v-model="order.teamName" name="teamName" label="队伍名称" readonly />
      <van-field v-model="order.objName" name="objName" label="费用说明" readonly />
      <van-field v-model="order.userPayment" name="userPayment" label="应付金额" readonly />
      <van-field v-model="type" label="支付方式" readonly />
    </van-form>
    <div class="bottom">
      <van-button type="info" block @click="bangsaishiCheckTeamSignupOrder"
        style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">支付费用</van-button>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import { Form, Field } from 'vant'
Vue.use(Form).use(Field)
import { getWXInfo, removeToken } from "@/libs/cookie-storage";
import { getOrderDetail, getWechatPrepayInfo,bangsaishiCheckTeamSignupOrder,bangsaishiCreateTeamSignupOrder,bangsaishiCreatePlayerSignupOrder} from "@/api/match";
import { ConstConfig } from "@/constants";
import { UrlUtil, isWeChatMiniApp } from "@/utils";
import { getPassport } from "@/libs/passport";
import { AppType } from '@/constants/appType'
import wx from 'weixin-js-sdk'

export default {
  name: "payment",
  data() {
    return {
      orderId: '',
      unionMatchId: '',
      order: {},
      type: '微信支付',
      category: 0,
      redirectUrl: 0,
      matchId: '',
      teamId: '',
      playerId: ''
    }
  },
  mounted() {
    getPassport().then(() => {
      const category = this.$route.query.category || 0
      this.category = Number(category)
      this.unionMatchId = this.$route.query.unionMatchId
      this.orderId = this.$route.query.orderId
      this.matchId = this.$route.query.matchId
      this.teamId = this.$route.query.teamId
      this.playerId = this.$route.query.playerId
      this.redirectUrl = localStorage.getItem('saas-redirect') || ''
      if (!this.redirectUrl) {
        const role = this.category === 0 ? 1 : 0
        this.redirectUrl = `${process.env.VUE_APP_BM_MATCH}#/entry-page/entry-list?unionMatchId=${this.unionMatchId}&role=${role}`
      }
      console.log(this.redirectUrl);
      this.getOrderDetail()
    })
  },
  methods: {
    // 立即支付
    getOrderDetail() {
      const params = {
        orderId: this.orderId,
        category: this.category
      }
      getOrderDetail(params).then(res => {
        if (res) {
          const { data } = res
          this.order = data || {}
          if (this.order.userPayment) {
            this.order.userPayment = (this.order.userPayment / 100).toFixed(2)
          }
        }
      })
    },
    pay() {
      if (AppType.isInWeChat()) {// 微信环境
        isWeChatMiniApp().then(res => {
          if (res) { // 小程序环境
            this.miniAppPayOrder(this.orderId)
          } else { // 微信H5环境
            this.getWechatPrepayInfo()
          }
        })
      } else {
        this.$toast('请在微信环境打开')
      }
    },
    bangsaishiCheckTeamSignupOrder() {
      bangsaishiCheckTeamSignupOrder({ orderId: this.orderId }).then(res => {
        if (res) {
          const { data } = res
          if (data.checkPrice) {
            this.pay()
          } else {
            if(this.category === 1){
              bangsaishiCreatePlayerSignupOrder({ matchId: this.matchId, teamId: this.teamId, playerId: this.playerId }).then(res => {
                if (res) {
                  this.orderId = res.data.orderId
                  this.pay()
                }
              })
            } else {  
               bangsaishiCreateTeamSignupOrder({matchId:this.matchId,teamId:this.teamId}).then(res=>{
              if(res){
                this.orderId = res.data.orderId
                this.pay()
                }
              })
            }
          }
        }
      })
    },
    getWechatPrepayInfo() {
      const wxInfo = getWXInfo()
      if (!wxInfo?.openId) {
        if (AppType.isInWeChat()) {
          removeToken()
          this.$toast('请刷新页面后重试')
          return
        } else {
          this.$toast('请在微信环境打开')
          return
        }
      }
      const data = {
        orderId: this.orderId,
        openId: wxInfo.openId,
        realPay: 1
      }
      getWechatPrepayInfo(data).then(res => {
        this.hrefWechatPay(res.data.payInfo.payInfo, this.orderId)
      })
    },
    // 调起支付
    hrefWechatPay(payInfo) {
      localStorage.removeItem('saas-redirect')
      const payUrl = ConstConfig.payUrl + '?' + UrlUtil.queryObjectToString({
        t: Date.now(),
        payInfo: JSON.stringify(payInfo),
        redirectUrl: this.redirectUrl
      })
      window.location.assign(payUrl)
    },
    miniAppPayOrder(orderId) {
      localStorage.removeItem('saas-redirect')
      // const url = '/pages/pay/index?orderId=' + orderId
      const url = `/pages/pay/index?orderId=${orderId}&redirectUrl=${encodeURIComponent(this.redirectUrl)}`
      wx.miniProgram.navigateTo({ url })
    },
  }
};
</script>

<style lang="scss" scoped>
.payment {
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
</style>
